import ENV from "config/Env";
import { backendQueryKey } from "hooks";

import type { User } from "models";
import type { DayplannerAppointment } from "modules/Dayplanner";

const component = "Dayplanner";

export const DayplannerKeys = {
  appointments: backendQueryKey<DayplannerAppointment[]>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/dayplanner/appointments/list" }),
  mechanics: backendQueryKey<User[]>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/dayplanner/mechanics/list" })
};
